<template lang="pug">
	div.flex.min-h-screen.justify-center.bg-white
		.w-full.max-w-5xl.mt-32.pb-32

			.flex.align-center.font-medium
				router-link.flex.align-center(to="/")
					span Dashboard
				p.flex.align-center.text-gray-6
					span.opacity-25.mx-2.font-bold /
					span Settings
			
			h2.font-semibold.text-2xl.text-gray-9.mt-2.pb-4.border-b Settings

			.mt-6.flex.pb-6.border-b
				.rounded-full.w-8.h-8.mr-4.bg-blue-5.flex.justify-center.items-center.-ml-12.flex-shrink-0(class="lg:ml-0")
					eva-icon.icon.text-white(width="16" height="16" name="person")
				
				div
					h3.font-semibold Personal info
					label.mt-4.mb-1 Display name
					
					.flex.items-center
						input.w-64(:placeholder="profile.displayName" v-model="displayName" :disabled="isUpdatingDisplayName" @keyup.enter="blur" @blur="updateDisplayName")
						eva-icon.icon.text-gray-5.spin.ml-2(v-if="isUpdatingDisplayName" name="loader-outline")
					
					button.mt-4.flex.py-1.px-2.-ml-2.text-indigo-9.font-semibold.w-auto.shadow-none(@click="sendPasswordResetEmail(profile.email)" v-if="provider != 'google.com'") Change password
			
			.mt-6.flex.pb-6.border-b(v-if="isAdmin(uid)")
				.rounded-full.w-8.h-8.mr-4.bg-green-6.flex.justify-center.items-center.-ml-12.flex-shrink-0(class="lg:ml-0")
					eva-icon.icon.text-white(width="16" height="16" name="briefcase")
				
				
				.w-full
					h3.font-semibold Company details
					.flex(class="md:flex-col")
						div.mr-4
							label.mt-4.mb-1 Company name
							
							.flex.items-center
								input.w-64(:placeholder="company.name" v-model="companyName" :disabled="isUpdatingCompanyName" @keyup.enter="blur" @blur="updateCompanyName")
								eva-icon.icon.text-gray-5.spin.ml-2(v-if="isUpdatingCompanyName" name="loader-outline")
						
						.flex-grow.max-w-sm
							label.mt-4.mb-1 Company purpose
							
							.flex.items-center
								input.w-full(:placeholder="company.purpose" v-model="companyPurpose" :disabled="isUpdatingCompanyPurpose" @keyup.enter="blur" @blur="updateCompanyPurpose")
								eva-icon.icon.text-gray-5.spin.ml-2(v-if="isUpdatingCompanyPurpose" name="loader-outline")
			
			.mt-6.flex.pb-6.border-b.relative
				.rounded-full.w-8.h-8.mr-4.bg-pink-6.flex.justify-center.items-center.-ml-12.flex-shrink-0(class="lg:ml-0")
					eva-icon.icon.text-white(width="16" height="16" name="people")
				
				.w-full
					h3.font-semibold Teammates

					.flex.mt-8.mb-1.border-b.pb-2(class="md:hidden")
						label.w-64.text-sm Teammate
						label.text-sm Teams

					transition-group(name="collapse")
						.flex.h-20.items-center.relative.rounded-lg.px-2.-mx-2(class="hover:bg-gray-0 md:flex-col md:items-start md:mt-6 md:h-auto" v-for="(teammate, index) in teammates" :key="teammate.id")
							.flex.items-center.w-64(class="md:mb-2")
								Avatar(:profile="teammate" size="small")
								.ml-4(class="md:ml-2")
									p.font-semibold.text-sm {{teammate.displayName}}
									p.text-gray-6.text-xs {{teammate.email}}
							
							.flex.items-center.flex-grow(class="md:flex-col md:items-start md:ml-8")
								Teams.flex-grow(:selectedTeams="teammate.teams" parentType="user" :parentId="teammate.id" :denyEdit="uid !== teammate.id  || isAdmin(uid)")
								.flex(v-if="isAdmin(uid)")
									button.text-sm.flex.py-1.px-2.text-gray-7.font-semibold.shadow-none.w-auto(v-if="uid != teammate.id" @click="removeMember(teammate.id)") Remove
									.flex.w-24.relative
										button.text-sm.small.flex.justify-between.w-full.py-1.px-2.text-gray-7.font-semibold.shadow-none.w-auto(@click="showRoleDropdown = teammate.id")
											span(v-if="isAdmin(teammate.id)") Admin
											span(v-else) Regular
											eva-icon.icon.text-gray-4(name="chevron-down")
									
										.absolute.left-0.top-0(v-if="showRoleDropdown == teammate.id")
											.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showRoleDropdown = ''")
											.relative.bg-white.p-2.shadow-xl.mt-10.rounded-lg.z-10
												.p-1.px-2.rounded-lg.my-1.cursor-pointer(class="hover:bg-gray-1" :class="{ selected: isAdmin(teammate.id) }" @click="addToAdmins(teammate.id)") Admin
												.p-1.px-2.rounded-lg.my-1.cursor-pointer(class="hover:bg-gray-1" :class="{ selected: !isAdmin(teammate.id) }" @click="removeFromAdmins(teammate.id)") Regular

								p.uppercase.text-xs.font-semibold.text-gray-6.ml-2(v-else) 
									span(v-if="isAdmin(teammate.id)") Admin		
							.blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.justify-center.items-center.-m-1(v-if="removingMember == teammate.id || isSettingRole == teammate.id")
								eva-icon.icon.spin.text-gray-6(name="loader-outline")

					transition-group(name="collapse")
						.flex.h-20.items-center.relative.rounded-lg.px-2.-mx-2(class="hover:bg-gray-0 md:flex-col md:items-start md:mt-6 md:h-auto" v-for="(invite, index) in company.invites" :key="index")
							.flex.items-center.w-64(class="md:mb-2")
								.h-8.w-8.rounded-full.bg-gray-2.flex.items-center.justify-center.uppercase {{invite[0]}}
								.ml-4(class="md:ml-2")
									p.font-semibold.text-sm {{invite}}
							
							.flex.items-center.flex-grow(class="md:flex-col md:items-start md:ml-8")
								
								.flex(v-if="!isAdmin(uid)")
									button.text-sm.flex.py-1.px-2.text-gray-7.font-semibold.shadow-none.w-auto(@click="sendInvites([invite])") Resend invite
					
					.relative
						button.mt-4.flex.py-1.px-2.-ml-2.text-indigo-9.font-semibold.w-auto.shadow-none(@click="showInviteDropdown = true") Invite teammate(s)
						.dropdown.absolute.left-0.top-0(v-if="showInviteDropdown")
							.fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showInviteDropdown = false")
							form.relative.bg-white.p-4.shadow-xl.mt-10.rounded-lg.z-10(@submit.prevent="inviteTeammates")
								label Teammate(s) email
								input.p-2(:class="{error: inviteError.length}" v-model="invitees")
								p.error-text(v-if="inviteError.length") {{inviteError}}
								p.help-text To add multiple, seperate by a comma: ","
								button.main.mt-2(type="submit") Send invitation(s)
				.blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.justify-center.items-center.-m-1(v-if="sendingInvites")
					eva-icon.icon.spin.text-gray-6(name="loader-outline")
			.mt-6.flex.pb-6.border-b(v-if="isAdmin(uid)")
				.rounded-full.w-8.h-8.mr-4.bg-orange-5.flex.justify-center.items-center.-ml-12.flex-shrink-0(class="lg:ml-0")
					eva-icon.icon.text-white(width="16" height="16" name="bell")
				
				div
					h3.font-semibold Notifications
					p.text-gray-6 When Wangll will request relevant teammates to provide updates on goals
					
					.flex.items-center.mt-2
						select.w-32.mr-2(@input="updateUpdateDay" ref="day")
							option(v-for="day in days" :selected="day == company.updateDay") {{day}}
						
						select.w-32(@input="updateUpdateTime" ref="time")
							option(v-for="time in times" :selected="time == company.updateTime") {{time}}
						
						eva-icon.icon.text-gray-5.spin.ml-2(v-if="editingDay || editingTime" name="loader-outline")
					
					.text-sm.text-gray-6.inline-flex.items-center.mt-2
						eva-icon.icon.text-gray-5(name="info" width="16" height="16")
						span.ml-1 Reports will be sent the next day, same time.

			.mt-6.flex.pb-6.border-bcompany.updateDay(v-if="isAdmin(uid)")
				.rounded-full.w-8.h-8.mr-4.bg-grape-9.flex.justify-center.items-center.-ml-12.flex-shrink-0(class="lg:ml-0")
					img(width="16" height="16" src="../assets/images/slack.svg")
				
				div
					h3.font-semibold Slack integration
					p.text-gray-6 Wangll will request for updates via slack instead of email
					p Coming soon
					//button.mt-4.flex.py-1.px-2.-ml-2.text-indigo-9.font-semibold.w-auto.shadow-none Connect
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../templates/Modal";
import Avatar from "../components/Avatar";
import Teams from "../components/Teams";
import { auth } from "../firebase.config";

export default {
  components: { Modal, Avatar, Teams },
  name: "Settings",
  data() {
    return {
      companyName: "",
      companyPurpose: "",
      displayName: "",
      isUpdatingDisplayName: false,
      isUpdatingCompanyName: false,
      isUpdatingCompanyPurpose: false,
      provider: "",
      removingMember: "",
      isSettingRole: "",
      showRoleDropdown: false,
      showInviteDropdown: false,
      sendingInvites: false,
      invitees: "",
      inviteError: "",
      times: [],
      days: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      editingTime: false,
      editingDay: false,
      uid: auth.currentUser.uid
    };
  },
  created() {
    this.provider = auth.currentUser.providerData[0].providerId;
    //console.log(JSON.stringify(this.teammates));

    var x = 30; // minutes interval
    var times = []; // time array
    var tt = 480; // start time
    var ap = [" am", " pm"]; // AM-PM

    //loop to increment the time and push results in array
    for (var i = 0; tt < 19 * 60; i++) {
      var hh = Math.floor(tt / 60); // getting hours of day in 0-24 format
      var mm = tt % 60; // getting minutes of the hour in 0-55 format
      times[i] =
        ("" + (hh == 12 ? 12 : hh % 12)).slice(-2) +
        ":" +
        ("0" + mm).slice(-2) +
        ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
      tt = tt + x;
    }

    this.times = times;
  },
  computed: {
    ...mapGetters(["profile", "company", "teammates"]),
    companyUpdateDate() {
      return this.company.updateDay + " " + this.company.updateTime;
    }
  },
  methods: {
    ...mapActions(["blur", "sendPasswordResetEmail"]),
    sendInvites(invitees) {
      this.sendingInvites = true;
      const teammates = [];
      invitees.forEach(async (invitee, index, array) => {
        const colour = await this.$store.dispatch("pickColour");
        const teammate = {
          colour: colour,
          email: invitee,
          displayName: "",
          teams: []
        };
        teammates.push(teammate);
        if (index == array.length - 1) {
          this.$store
            .dispatch("inviteTeammates", teammates)
            .then(() =>
              this.$store.dispatch("fireNotification", {
                title: "Sent invites!",
                type: "success",
                icon: "email-outline"
              })
            )
            .then(() =>
              this.$store.dispatch("getCompany", this.profile.companyId)
            )
            .then(() => (this.sendingInvites = false));
        }
      });
    },
    inviteTeammates() {
      const invitees = this.invitees.split(",").map(item => item.trim());
      if (!this.invitees.length) return;
      this.inviteError = "";

      invitees.forEach(async (invitee, index, array) => {
        const isEmail = await this.$store.dispatch("isEmail", invitee);

        if (!isEmail)
          this.inviteError =
            "Please make sure they are all proper email addresses";
        if (index == array.length - 1) {
          if (this.inviteError.length) return;

          this.showInviteDropdown = false;

          this.sendInvites(invitees);
        }
      });
    },
    updateDisplayName() {
      if (!this.displayName || this.displayName == this.profile.displayName)
        return;

      this.isUpdatingDisplayName = true;

      this.$store
        .dispatch("updateDoc", {
          collection: "users",
          id: auth.currentUser.uid,
          item: { displayName: this.displayName }
        })
        .then(() => {
          this.isUpdatingDisplayName = false;
          this.$store.dispatch("getUserProfile", auth.currentUser);
          this.$store.dispatch("getTeammates", this.profile.companyId);
          this.$store.dispatch("fireNotification", {
            title: "Updated your display name",
            type: "success"
          });
        })
        .catch(() => (this.isUpdatingDisplayName = false));
    },
    updateCompanyName() {
      if (!this.companyName || this.companyName == this.company.name) return;

      this.isUpdatingCompanyName = true;

      this.$store
        .dispatch("updateDoc", {
          collection: "companies",
          id: this.profile.companyId,
          item: { name: this.companyName }
        })
        .then(() => {
          this.isUpdatingCompanyName = false;
          this.$store.dispatch("getCompany", this.profile.companyId);
          this.$store.dispatch("fireNotification", {
            title: "Updated your company name",
            type: "success"
          });
        })
        .catch(() => (this.isUpdatingCompanyName = false));
    },
    updateCompanyPurpose() {
      if (!this.companyPurpose || this.companyPurpose == this.company.purpose)
        return;

      this.isUpdatingCompanyPurpose = true;

      this.$store
        .dispatch("updateDoc", {
          collection: "companies",
          id: this.profile.companyId,
          item: { purpose: this.companyPurpose }
        })
        .then(() => {
          this.isUpdatingCompanyPurpose = false;
          this.$store.dispatch("getCompany", this.profile.companyId);
          this.$store.dispatch("fireNotification", {
            title: "Updated your company’s purpose",
            type: "success"
          });
        })
        .catch(() => (this.isUpdatingCompanyPurpose = false));
    },
    updateUpdateDay(event) {
      const day = event.currentTarget.value;

      this.editingDay = true;

      this.$store
        .dispatch("updateDoc", {
          collection: "companies",
          id: this.profile.companyId,
          item: { updateDay: day }
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: `Wangll will request updates on ${day}s`,
            type: "success"
          });
          return this.$store.dispatch("getCompany", this.profile.companyId);
        })
        .then(() => {
          this.editingDay = false;
        })
        .catch(() => (this.editingDay = false));
    },
    updateUpdateTime(event) {
      const time = event.currentTarget.value;

      this.editingTime = true;

      this.$store
        .dispatch("updateDoc", {
          collection: "companies",
          id: this.profile.companyId,
          item: { updateTime: time }
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: `Wangll will request updates at ${time}`,
            type: "success"
          });
          return this.$store.dispatch("getCompany", this.profile.companyId);
        })
        .then(() => {
          this.editingTime = false;
        })
        .catch(() => (this.editingTime = false));
    },
    removeMember(uid) {
      this.removingMember = uid;
      this.$store.dispatch("fireNotification", {
        title: "Removing teammate...",
        timeOut: 5000,
        actions: [
          {
            text: "Undo",
            do: "updateDoc",
            payload: {
              collection: "users",
              id: uid,
              item: { companyId: this.profile.companyId }
            },
            then: "getTeammates",
            thenPayload: this.profile.companyId
          }
        ]
      });

      this.$store
        .dispatch("updateDoc", {
          collection: "users",
          id: uid,
          item: { companyId: "" }
        })
        .then(() => {
          return this.$store.dispatch("getTeammates", this.profile.companyId);
        })
        .then(() => {
          this.removingMember = "";
        });
    },
    isAdmin(id) {
      return this.company.admins.some(admin => admin == id);
    },
    addToAdmins(id) {
      this.isSettingRole = id;
      this.showRoleDropdown = false;

      this.$store
        .dispatch("arrayUnion", {
          collection: "companies",
          id: this.profile.companyId,
          array: "admins",
          item: id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Changed role to admin",
            type: "success"
          });
          return this.$store.dispatch("getCompany", this.profile.companyId);
        })
        .then(() => {
          this.isSettingRole = false;
        })
        .catch(() => {
          this.isSettingRole = false;
        });
    },
    removeFromAdmins(id) {
      this.isSettingRole = id;
      this.showRoleDropdown = false;

      this.$store
        .dispatch("arrayDelete", {
          collection: "companies",
          id: this.profile.companyId,
          array: "admins",
          item: id
        })
        .then(() => {
          this.$store.dispatch("fireNotification", {
            title: "Changed role to regular",
            type: "success"
          });
          return this.$store.dispatch("getCompany", this.profile.companyId);
        })
        .then(() => {
          this.isSettingRole = false;
        })
        .catch(() => {
          this.isSettingRole = false;
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.tab
  margin-top: 2px

::placeholder
  color: #212529 !important

.selected
  @apply border-2 border-indigo-6
</style>
